<template>
  <div>
    <Grid />
  </div>
</template>

<script>
import Grid from "@/components/compra/ProdutosGerais/ListaProdutos/Grid.vue";

export default {
  name: "Index",
  components: {
    Grid
  }
}
</script>

<style scoped>

</style>
